import { AssetGrid } from './asset-grid'

export function AssetHubPage() {
	return (
		<div className="ring ring-grey-100 rounded-sm h-full">
			<AssetGrid mode="page" allowDelete={true} />
		</div>
	)
}
